import type { ParserTracer } from 'peggy'

import * as expressionParser from '../../generated/expression.js'
import type { ViewQueryRecordNodeWithParent } from '../functions/util/recordNodeUtility.ts'
import { compileExpression, type CoreDslParameter } from './compile.ts'
import { flatAstNode } from './flat.ts'
import { PeggyTracer } from './PeggyTracer.ts'
import type { ExpressionNodeWithDeprecated } from './syntax/expression_ast.ts'
import { toString } from './toString.ts'

// eslint-disable-next-line @typescript-eslint/no-extraneous-class
export class CoreDsl {
  public static parse(x: string) {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-type-assertion
    const tracer = new PeggyTracer() as unknown as ParserTracer // tracerを使うには、--traceオプションをつけてpeggyを実行してパーサーを生成する必要がある
    try {
      // eslint-disable-next-line @typescript-eslint/no-unsafe-type-assertion
      const ast = expressionParser.parse(x, { tracer }) as ExpressionNodeWithDeprecated

      return {
        success: true as const,
        data: ast,
      }
    } catch (error) {
      return {
        success: false as const,
        error,
      }
    }
  }

  // deprecated. compileWithRecordNodeを使ってください。
  public static compile(exp: unknown, parameter?: CoreDslParameter) {
    try {
      // eslint-disable-next-line @typescript-eslint/no-unsafe-type-assertion
      const data = compileExpression(exp as ExpressionNodeWithDeprecated, parameter ?? {})
      return {
        success: true as const,
        data,
      }
    } catch (error) {
      return {
        success: false as const,
        error,
      }
    }
  }

  // expにはExpressionNodeWithDeprecatedを期待するが、
  // zodが循環参照を表現できないためexpをzodで書けず、unknownになっているのでunknownで受け取る。
  public static compileWithRecordNode(
    exp: unknown,
    record: ViewQueryRecordNodeWithParent,
    parameter?: CoreDslParameter,
  ) {
    return this.compile(exp, {
      ...record.attributes,
      ...record,
      ...parameter,
      // deprecated
      recordNode: record,
      parentRecordNode: record.parent,
    })
  }

  public static execute(exp: string, parameter?: CoreDslParameter) {
    const ast = this.parse(exp)
    if (!ast.success) {
      return ast
    }
    return {
      success: true as const,
      data: this.compile(ast.data, parameter),
    }
  }

  public static executeWithRecordNode(exp: string, record: ViewQueryRecordNodeWithParent) {
    const parameter = getRecordParameter(record)
    return this.execute(exp, parameter)
  }

  public static flat(ast: ExpressionNodeWithDeprecated) {
    return flatAstNode(ast)
  }

  public static stringify(ast: ExpressionNodeWithDeprecated | undefined): string {
    return toString(ast)
  }
}

function getRecordParameter(record: ViewQueryRecordNodeWithParent) {
  return {
    ...record.attributes,
    ...record,
    // deprecated
    recordNode: record,
    parentRecordNode: record.parent,
  }
}
